<template>
  <div class="header mt-2">
    <div :class="{ 'size-1': size === 1, 'size-2': size === 2 }">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type: Number,
      default: 1,
    },
  },
};
</script>
<style scoped>
.header {
  border-bottom: 1px black solid;
}
</style>
<style>
.header .size-1 {
  font-weight: bold;
  font-size: 20px;
}

.header .size-2 {
  font-size: 14px;
  padding: 0 12px 0 12px;
}
</style>
